import api from "../../service/api";
import ConfigureInfo from "@/connect/configureInfo";

export default {
  state: () => ({
    lastFundingRateDetails: [],
    queryFundingData: [],
    isFundingSettlement: false,
    IntervalFunding: null,
  }),
  mutations: {
    SET_INTERVAL_FUNDING(state, opt) {
      state.IntervalFunding = opt;
    },
    SET_QUERY_FUNDING_DATA(state, opt) {
      state.queryFundingData = opt;
    },
    SET_QUERY_FUNDING_LAST_DATA(state, opt) {
      state.lastFundingRateDetails = opt;
    },
    SET_FUNDING_SETTLEMENT(state, opt) {
      state.isFundingSettlement = opt;
    },
  },
  actions: {
    async getFundingRateRealTime({ commit, rootState }) {
      const getFundingRateRealTimeData = await api["getFundingRateRealTime"]({
        pair: rootState.tradingPair.queryPairInfo.pair,
      });

      commit("SET_QUERY_FUNDING_LAST_DATA", [getFundingRateRealTimeData]);

      return getFundingRateRealTimeData;
    },

    setIntervalFundingRateRealTime({ dispatch, commit, state }) {
      clearInterval(state.IntervalFunding);
      commit("SET_INTERVAL_FUNDING", null);

      commit(
        "SET_INTERVAL_FUNDING",
        setInterval(async () => {
          const getFundingRateRealTimeData = await dispatch(
            "getFundingRateRealTime"
          );
          commit("SET_QUERY_FUNDING_LAST_DATA", [getFundingRateRealTimeData]);
        }, 300000)
      );
    },
    async getQueryFunding({ commit, rootState }, isFindingSubscribe = true) {
      const queryFundingData = await api["queryFunding"]({
        pair: rootState.tradingPair.queryPairInfo.pair,
      });

      commit(
        "SET_QUERY_FUNDING_DATA",
        queryFundingData.settleFundingRateDetails
      );

      commit(
        "SET_QUERY_FUNDING_LAST_DATA",
        queryFundingData.lastFundingRateDetails
      );

      if (isFindingSubscribe) {
        rootState.ws.websocketsend({
          type: "subscribe",
          channel: "funding_rate",
          // id: rootState.tradingPair.queryPairInfo.pair,
          last_height: "",
          chainId: ConfigureInfo.Marginx.chainId,
        });
      }
    },
    async setQueryFunding({ commit }, data) {
      // commit("SET_QUERY_FUNDING_DATA", data);
      if (
        data.settleFundingRateDetails &&
        data.settleFundingRateDetails.length > 0
      ) {
        commit("SET_QUERY_FUNDING_DATA", data.settleFundingRateDetails);
      }

      if (
        data.lastFundingRateDetails &&
        data.lastFundingRateDetails.length > 0
      ) {
        commit("SET_QUERY_FUNDING_LAST_DATA", data.lastFundingRateDetails);
      }
    },
  },
  getters: {
    getFundingInfo: (state, rootState) => {
      if (state.queryFundingData.length < 1) return {};

      const data = state.queryFundingData.filter((value) => {
        return value.pair === rootState.getQueryPairInfo.pair;
      });

      return data[0];
    },
    getLastFundingInfo: (state, rootState) => {
      if (state.lastFundingRateDetails.length < 1) return {};

      const data = state.lastFundingRateDetails.filter((value) => {
        return value.pair === rootState.getQueryPairInfo.pair;
      });

      return data[0];
    },
  },
};
